<div class="border rounded-md">
  <!-- <div class="grid grid-cols-2 bg-muted/50 p-2 border-b">
    <div class="flex items-center">
      <span class="font-medium">Origen</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4 ml-1"><path d="m18 8 4 4-4 4"/><path d="m6 8-4 4 4 4"/><path d="M14 4v16"/><path d="M10 4v16"/></svg>
    </div>
    <div class="flex items-center">
      <span class="font-medium">Destino</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4 ml-1"><path d="m18 8 4 4-4 4"/><path d="m6 8-4 4 4 4"/><path d="M14 4v16"/><path d="M10 4v16"/></svg>
    </div>
  </div> -->
  <div class="border rounded-lg overflow-hidden">
    <table class="w-full">
      <thead class="bg-gray-100">
        <tr class="border border-gray-300 p-2 bg-gray-200">
          @for (column of columns; track column) { 
            <ng-container *ngTemplateOutlet="columnTemplates.get(column.key); context: { isHeader: true }"></ng-container>
          }
          <!-- @for (row of rows; track row) {
            <th class="cursor-pointer p-3">{{row.header}}</th>
          } -->
          <!-- <th (click)="handleSort('role')" class="cursor-pointer p-3">Rol</th> -->
          <!-- <th class="p-3 text-right">Acciones</th> -->
        </tr>
      </thead>
      <tbody class="font-semibold">
        @for (row of rows; track row) {
          <tr>
            @for (column of columns; track column) {
              <td class="border border-gray-300 p-2">
                <ng-container *ngTemplateOutlet="columnTemplates.get(column.key); context: { row: row, isHeader: false }"></ng-container>
              </td>
            }
            <!-- <td *ngFor="let template of templates.toArray()" class="border border-gray-300 p-2">
            </td>
            <ng-content select="rows"></ng-content> -->
            <!-- <td class="p-3">{{ row.name }}</td>
            <td class="p-3">
              <span [ngClass]="{'bg-[#00BFB3] text-white px-2 py-1 rounded': group.role === 'EDA_ADMIN_ROLE'}">
                {{ group.role }}
              </span>
            </td>
            <td class="p-3 text-right">
              <button class="rounded-md p-2 cursor-pointer hover:bg-muted" (click)="handleEditGroup(group)">
                <eda-icon name="pencil"></eda-icon>
              </button>
              <button class="rounded-md p-2 cursor-pointer hover:bg-muted" (click)="handleDeleteGroup(group._id)">
                <eda-icon name="bin"></eda-icon>
              </button>
            </td> -->
          </tr>
        }
      </tbody>
    </table>
  </div>
  
  <div class="flex items-center justify-between p-2 border-t bg-muted/20">
    <div class="flex items-center space-x-1">
      <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0" disabled>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="M11 17l-5-5 5-5"/><path d="M17 17l-5-5 5-5"/></svg>
      </button>
      <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0" disabled>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m15 18-6-6 6-6"/></svg>
      </button>
      <span class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary/10 border border-primary/20 px-2.5 py-0.5">1</span>
      <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0" disabled>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m9 18 6-6-6-6"/></svg>
      </button>
      <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0" disabled>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m13 17 5-5-5-5"/><path d="m7 17 5-5-5-5"/></svg>
      </button>
    </div>
    <div class="text-sm text-muted-foreground">
      2 registros
    </div>
  </div>
</div>



  <!-- <p class="mt-1 font-semibold text-right text-gray-500">{{ filteredGroups.length }} grupos encontrados</p>
  <div class="flex justify-center items-center gap-2 mt-4">
    <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1" class="px-4 py-2 font-semibold rounded">
      <eda-icon name="chevron-left"></eda-icon>
    </button>
    <span class="font-semibold">Página {{ currentPage }} de {{ totalPages() }}</span>
    <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages()" class="px-4 py-2 font-semibold rounded">
      <eda-icon name="chevron-right"></eda-icon>
    </button>
  </div> -->